import React from 'react';
import FormRow from '../Form/FormRow';
import FormColumn from '../Form/FormColumn';
import { Input, Label } from '../Form';
import { Text } from 'rebass';

export type UserLoginInput = {
  email: string;
  password: string;
  confirmPassword: string;
};

type UserLoginFormProps = {
  value?: Partial<UserLoginInput>;
  onChange: (values: UserLoginInput) => void;
  disabled?: boolean;
};

const UserLoginForm: React.FC<UserLoginFormProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const handleUserInputChange = (e: any) => {
    const { name, value: inputValue } = e.target;

    onChange({
      email: value?.email ?? '',
      password: value?.password ?? '',
      confirmPassword: value?.confirmPassword ?? '',
      [name]: inputValue,
    });
  };

  return (
    <>
      <FormRow>
        <FormColumn>
          <Label>Email</Label>
          <Input
            width="100%"
            type="text"
            value={value?.email ?? ''}
            onChange={handleUserInputChange}
            name="email"
            autoComplete="off"
            disabled={disabled}
          />
        </FormColumn>
      </FormRow>
      <FormRow>
        <FormColumn>
          <Label>Password</Label>
          <Input
            width="100%"
            type="password"
            value={value?.password ?? ''}
            onChange={handleUserInputChange}
            name="password"
            autoComplete="new-password"
            disabled={disabled}
          />
          {value?.password && value.password.length < 7 && (
            <Text variant="body2" color="danger" mt={2}>
              Passwords must be at least 8 characters long
            </Text>
          )}
        </FormColumn>
        <FormColumn>
          <Label>Confirm Password</Label>
          <Input
            width="100%"
            type="password"
            value={value?.confirmPassword ?? ''}
            onChange={handleUserInputChange}
            name="confirmPassword"
            autoComplete="off"
            disabled={disabled}
          />
          {value?.password &&
            value?.confirmPassword &&
            value.password !== value.confirmPassword && (
              <Text variant="body2" color="danger" mt={2}>
                Passwords must match
              </Text>
            )}
        </FormColumn>
      </FormRow>
    </>
  );
};

export default UserLoginForm;
